// src/menus/JapaneseMenu.js
import React from 'react';
import CollapsibleSection from '../components/CollapsibleSection';
import '../styles/MultiSelect.css';

// Shared topics list (if needed for Vocabulary mode)
const topicsList = [
    "Relationships",
    "School and Education",
    "Career",
    "Shopping & Money",
    "Health and Wellness",
    "Food & Dining",
    "Travel & Adventure",
    "Weather & Nature",
    "Science",
    "Technology",
    "History",
    "Philosophy & Deep Thoughts",
    "Spirituality and Religion",
    "Movies & TV",
    "Music",
    "Hobbies & Interests",
    "Colors, Numbers, & Shapes",
    "Fun Facts!"
];

// Grammar items per JLPT level
export const japaneseGrammarItems = {
    "N5": [
        "だ / です (da / desu): to be (copula)",
        "だけ (dake): only, just",
        "だろう (darou): probably",
        "で (de): at, in",
        "で (de): with, by",
        "でしょう (deshou): I think, probably",
        "が (ga): subject marker",
        "が (ga): but, however",
        "がある (gaaru): there is (used for non-living things)",
        "がいる (gairu): there is (used for living things)",
        "ほうがいい (hou ga ii): it'd be better to",
        "ほうがいい (hou ga ii): it'd be better to not",
        "いちばん (ichiban): the most",
        "か (ka): or (A or B, choice between 2 objects)",
        "か (ka): question particle",
        "から (kara): because, since",
        "から (kara): from",
        "けれども (keredomo): but, although",
        "くらい (kurai): about, approximately",
        "まだ (mada): still, not yet",
        "まで (made): until, till, to, even",
        "まえに (mae ni): before",
        "ませんか (masen ka): let's, won't you",
        "ましょう (mashou): let's, shall we",
        "も (mo): also, too, as well",
        "もう (mo): already, anymore",
        "な (na): don't do",
        "ないでください (naidekudasai): please don't",
        "なる (naru): to become",
        "に (ni): in, at, to, for",
        "に/へ (ni/e): to",
        "にいく (ni iku): to go in order to",
        "にする (nisuru): to decide on",
        "の (no): of (indicates possessive)",
        "の (no): Verb nominalizer",
        "ので (node): because of, the reason is that",
        "のがじょうず (no ga jouzu): to be good at",
        "のがすき (no ga suki): like / love doing",
        "のがへた (no ga heta): to be bad at",
        "たい (tai): want to",
        "たことがある (takotogaaru): have done before",
        "ている (teiru): is/are/am doing",
        "てください (tekudasai): please do…",
        "てもいい (temo ii): is okay, is alright to, can",
        "てから (tekara): after doing",
        "てはいけない (tewaikenai): must not, may not",
        "と (to): and, with",
        "つもりだ: plan to, intend to",
        "や (ya): and",
        "より ~ のほうが ~ (yori ~ nohouga ~): is more ~ than"
    ],
    "N4": [
        "あまり～ない (amari~nai): not very, not much",
        "あとで (ato de): after, later",
        "ば (ba): if… then",
        "場合は (baai wa): in the event of",
        "ばかり (bakari): only, nothing but",
        "だけで (dake de): just by",
        "だす (dasu): to suddenly begin, to suddenly appear",
        "でも (demo): or something",
        "でございます (de gozaimasu): to be (honorific)",
        "がる (garu): to show signs of, to feel, to think",
        "がする (ga suru): smell, hear, taste",
        "ごろ (goro): around, about",
        "ございます (gozaimasu): to be, to exist (honorific)",
        "はじめる (hajimeru): to start, to begin to",
        "はずだ (hazu da): it must be, it should be",
        "はずがない (hazu ga nai): cannot be",
        "ひつよう (hitsuyou): need, necessary",
        "ひつようがある (hitsuyou ga aru): it is necessary to",
        "ほしい (hoshii): to want something, to be in need of",
        "いらっしゃる (irassharu): to be, to come, to go",
        "いたす (itasu): to do (honorific)",
        "じゃないか (janai ka): isn't it",
        "かどうか (ka dou ka): whether or not",
        "かい (kai): (turns a sentence into a yes/no question)",
        "かもしれない (kamoshirenai): might, maybe",
        "かな (kana): I wonder",
        "かた (kata): how to",
        "かしら (kashira): I wonder",
        "こと (koto): Verb nominalizer",
        "ことができる (koto ga dekiru): can, be able to",
        "ことになる (koto ni naru): it has been decided that",
        "ことにする (koto ni suru): to decide on",
        "までに (made ni): by, by the time",
        "みたい (mitai): like, similar to, resembling",
        "みたいに/みたいな (mitai ni/mitai na): like, similar to",
        "など (nado): such as, things like",
        "ながら (nagara): while, during, as",
        "ないで (naide): without doing, don't",
        "なければいけない/なければならない (nakereba ikenai/nakereba naranai): must do, have to do",
        "なくてはいけない/なくてはならない (nakutewa ikenai/nakutewa naranai): must do, have to do",
        "なくてもいい (nakute mo ii): don't have to",
        "なら (nara): if, in case, as for",
        "なさい (nasai): command (order somebody to do something)",
        "なさる (nasaru): to do (honorific)",
        "にくい (nikui): difficult to, hard to",
        "のなかで (no naka de): in, among",
        "のに(noni) – 1: in order to",
        "のに (noni) – 2: although, in spite of, even though",
        "のように / のような (no you ni/no you na): like, similar to",
        "お～ください (o~kudasai): please do (honorific)",
        "お～になる (o~ni naru): to do (honorific)",
        "おきに (oki ni): repeated at intervals, every",
        "おわる (owaru): to finish, to end",
        "られる (rareru) – 1: to be able to do something",
        "られる (rareru) – 2: (passive voice)",
        "らしい (rashii): seems like",
        "さ (sa): (nominalizer for adjectives)",
        "させる (saseru): to make/let somebody do something",
        "させられる (saserareru): to be made to do something",
        "し (shi): and",
        "しか～ない (shika~nai): only, nothing but",
        "そんなに (sonna ni): so, so much, like that",
        "それでも (sore demo): but still, and yet",
        "そうに/そうな (sou ni/sou na): seem, look like",
        "そうだ (sou da) – 1: I heard that, it is said that",
        "そうだ (sou da) – 2: look like, appear, seem",
        "すぎる (sugiru): too much",
        "たばかり (ta bakari): just did, something just happened",
        "たがる (tagaru): to want to",
        "たら (tara): if, after, when",
        "たらどう (tara dou): why don't you",
        "たり～たり (tari~tari): do such things like",
        "たところ (ta tokoro): just finished doing, was just doing",
        "てあげる (te ageru): to do something for someone",
        "てある (te aru): something is/has been done",
        "てほしい (te hoshii): I need you to",
        "ていく (te iku): to go on, to start",
        "ているところ (teiru tokoro): in the process of doing",
        "ていただけませんか (te itadakemasen ka): could you please",
        "てくれる (te kureru): to do something for someone",
        "てくる (te kuru): to come to, to become, to continue",
        "てみる (te miru): to try to",
        "ても (temo): even if, even though",
        "てもらう (te morau): to get somebody to do something",
        "ておく (te oku): to do something in advance",
        "てしまう (te shimau): to do something by accident, to finish completely",
        "てすみません (te sumimasen): I'm sorry for",
        "てよかった (te yokatta): I'm glad that",
        "と (to): if, when, and"
    ],
    "N3": [
        "あまり (amari): so much… that",
        "あまりに (amari ni): so much… that, too…",
        "ば～ほど (ba ~ hodo): the more… the more",
        "ばいい (ba ii): should, can, it'd be good if",
        "ばかりでなく (bakari denaku): not only… but also, as well as",
        "ばよかった (ba yokatta): should have, it would have been better if",
        "べき (beki): must do, should do",
        "べきではない (beki dewa nai): must not do, should not do",
        "べつに～ない (betsu ni ~ nai): not really, not particularly",
        "中 (chuu/juu): during, throughout",
        "だけ (dake): as much as",
        "だらけ (darake): covered all over in, full of",
        "どころか (dokoro ka): far from, anything but",
        "どんなに～ても (donna ni ~ temo): no matter how",
        "ふりをする (furi o suru): to pretend, to act as if",
        "ふと (futo): accidentally, unexpectedly",
        "がち (gachi): apt to do, tend to do",
        "がたい (gatai): hard to, difficult to",
        "ぎみ (gimi): -like, -looking",
        "ほど (hodo): the more, to the extent that, so much… that",
        "ほど～ない (hodo ~ nai): is not as… as",
        "いくら～ても (ikura ~ temo): no matter how",
        "一方だ (ippou da): more and more, continue to",
        "一方で (ippou de): on one hand, on the other hand",
        "かけ (kake): half-, not yet finished",
        "代わりに (kawari ni): instead of, in exchange for",
        "っけ (kke): what is… again?",
        "決して～ない (kesshite ~ nai): never, by no means",
        "切る (kiru): to do something completely to the end",
        "切れない (kirenai): being too much to finish or complete",
        "きり (kiri): only, just",
        "こそ (koso): for sure (emphasize preceding word)",
        "こと (koto): (must) do",
        "ことだ (koto da): should",
        "ことがある (koto ga aru): there are times when",
        "ことか (koto ka): how…! what…!",
        "ことに (koto ni): unusually, especially",
        "ことはない (koto wa nai): there is no need to, never happens",
        "くらい (kurai): to the extent that, so… that",
        "くせに (kuse ni): even though, and yet, despite",
        "まま (mama): as it is",
        "まるで (maru de): as if, as though",
        "めったに～ない (metta ni ~ nai): hardly, rarely, seldom",
        "もの (mono): because (indicate reason or excuse)",
        "ものだ (mono da): used to do something, should do something",
        "もしかしたら (moshikashitara): perhaps, maybe",
        "向き (muki): suitable for",
        "向け(muke): intended for, aimed at",
        "ながらも (nagara mo): but, although, despite",
        "ないことはない (nai koto wa nai): can, is not impossible",
        "なんか / なんて (nanka / nante): such as, things like",
        "なるべく (narubeku): as much as possible",
        "なぜなら (nazenara): because, the reason is",
        "に違いない (ni chigai nai): I'm sure, no doubt that",
        "にかけて (ni kakete): over (a period), through, concerning",
        "に関する / に関して (ni kansu ru / ni kanshite): related to",
        "にかわって (ni kawatte): in stead of, on behalf of",
        "に比べて (ni kurabete): compared to",
        "において/ における (ni oite / ni okeru): in, on, at, as for, regarding",
        "にしては (ni shite wa): for, considering it's",
        "にしても (ni shite mo): even if",
        "に対して (ni taishite): in contrast to, while, in regard to",
        "にとって (ni totte): to, for, concerning",
        "について (ni tsuite): concerning, regarding",
        "につれて (ni tsurete): as… then",
        "によると / によれば (ni yoru to / ni yoreba): according to",
        "によって / による (ni yotte / ni yoru): by means of, due to",
        "の間に (no aida ni): while, during",
        "を中心に (o chuushin ni): focused on, centered on",
        "をはじめ (o hajime): for example, starting with",
        "おかげで (okage de): thanks to, because of",
        "おそらく (osoraku): perhaps, likely, probably",
        "っぱなし (ppanashi): leaving something on, leaving something still in use",
        "っぽい (ppoi): -ish, -like",
        "さえ (sae): even",
        "さえ～ば (sae ~ ba): if only… then",
        "最中に (saichuu ni): in the middle of",
        "せいで (sei de): because of",
        "しかない (shika nai): have no choice but",
        "その結果 (sono kekka): as a result",
        "そうもない (sou mo nai): very unlikely to",
        "たびに (tabi ni): each time, every time, whenever",
        "ために (tame ni): for, for the sake of, in order to",
        "ために (tame ni): because of, as a result of",
        "たらいい/といい (tara ii / to ii): it would be nice if, should, I hope",
        "確かに (tashika ni): surely, certainly",
        "たとえ～ても (tatoe ~ temo): even if… is the case",
        "たとえば (tatoeba): for example",
        "た結果 / の結果 (ta kekka/no kekka): as a result of",
        "たとたん (ta totan): just (now, at the moment), as soon as",
        "てごらん (te goran): (please) try to, (please) look",
        "てはじめて (te hajimete): not until, only after… did I",
        "てもかまわない (temo kamawanai): it doesn't matter if",
        "途中に/途中で (tochuu ni/tochuu de): on the way, in the middle of",
        "といっても (to itte mo): although I say, although one might say",
        "という (to iu): called, named, as much as",
        "ということだ (to iu koto da): I've heard that, rumor has it that",
        "というのは (to iu nowa): means, is, because",
        "というと (to iu to): speaking of, if it were the case that",
        "というより (to iu yori): rather than",
        "ところで (tokoro de): by the way",
        "ところが (tokoro ga): even so, however, even though",
        "とおり (toori): in the way, the same as",
        "としたら / とすれば (to shitara / to sureba): if it were the case that, if we assume",
        "として (to shite): as (i.e. in the role of)",
        "とは限らない (towa kagiranai): not necessarily so, is not always true",
        "ついでに (tsuide ni): while you are at it, on the occasion",
        "つまり (tsumari): in other words; that is to say",
        "と共に (to tomo ni): together with",
        "うちに (uchi ni): while, before, doing",
        "わけだ (wake da): for that reason, no wonder, as you'd expect",
        "わけではない (wake dewa nai): it doesn't mean that, it is not the case",
        "わけがない (wake ga nai): there is no way that",
        "わけにはいかない (wake niwa ikanai): must not, can't afford to",
        "わりに (wari ni): although, rather, unexpectedly",
        "ような気がする (you na ki ga suru): have a feeling that, think that",
        "ように (you ni): in order to, so that",
        "ようとする (you to suru): try to, be about to",
        "ようとしない (you to shinai): not try to, not make an effort to",
        "ずに (zuni): without doing",
        "ずにはいられない (zu niwa irarenai): can't help but feel, can't help but do"
    ],
    "N2": [
        "あるいは (aruiwa): or, possibly",
        "ばかり (bakari): about, approximately",
        "ばかりだ (bakari da): continue to",
        "ばかりに (bakari ni): because, on account of",
        "ぶりに (buri ni): for the first time in",
        "ちっとも～ない (chitto mo~nai): not at all, not in the least",
        "だけあって (dake atte): …being the case, precisely because",
        "だけでなく (dake de naku): not only… but also",
        "だけましだ (dake mashi da): one should feel grateful for",
        "だけに (dake ni): …being the case, precisely because",
        "だけのことはある (dake no koto wa aru): no wonder, it's not surprising that",
        "だけは (dake wa): to do all that one can",
        "だって (datte): because, but",
        "(で)すら (de sura): even",
        "ではないか (dewa nai ka): let's do something, why don't we",
        "でしかない (de shika nai): merely, nothing but, no more than",
        "どころではない (dokoro dewa nai): this is not the time for…",
        "どうせ (douse): anyway, anyhow",
        "どうやら (dou yara): it seems like, it appears that",
        "える / うる (eru/uru): can, is possible",
        "えない (enai): unable to, cannot",
        "ふたたび (futatabi): again, once more",
        "ふうに (fuu ni): in a way (this way/that way/what way)",
        "げ (ge): [giving the appearance of]",
        "ごとに (goto ni): each, every, at intervals of",
        "逆に (gyaku ni): on the contrary",
        "いよいよ (iyoiyo): at last, finally",
        "反面 (hanmen): on the other hand",
        "果たして (hatashite): sure enough, really",
        "以上 (ijou): because, now that",
        "以上に (ijou ni): more than, no less than",
        "いきなり (ikinari): suddenly, all of a sudden",
        "いわゆる (iwayuru): so-called, so to speak",
        "上 (jou): from the standpoint of",
        "か～ないかのうちに (ka~nai ka no uchi ni): right after, as soon as",
        "かえって (kaette): on the contrary, rather, surprisingly",
        "かいがある(kai ga aru): it's worth one's effort to do something",
        "か何か (ka nanika): or something",
        "かねない (kanenai): might happen, might do something",
        "かねる (kaneru): unable to do something",
        "かのよう (ka no you): as if, just like",
        "から言うと (kara iu to): in terms of, from the point of view of",
        "からこそ (kara koso): precisely because",
        "から見ると (kara miru to): from the point of view of, by the look of",
        "からには (kara niwa): now that, since, so long as",
        "からして (kara shite): judging from, based on",
        "からすると / からすれば (kara suru to/kara sureba): judging from, considering",
        "からといって (kara to itte): just because",
        "かと思ったら / かと思うと (ka to omottara/ka to omou to): then again, just when, no sooner than",
        "限り (kagiri): as long as, while… is the case",
        "気 (ki): feel like",
        "っこない (kkonai): no chance of, … is definitely not possible",
        "ことだから (koto dakara): it is exactly because",
        "ことから (koto kara): from the fact that",
        "ことなく (koto naku): without doing something even once",
        "ことになっている (koto ni natte iru): to be expected to, to be scheduled to",
        "ことにはならない (koto niwa naranai): just because… doesn't mean…",
        "ことは～が (koto wa~ga): although, but",
        "まい (mai): won't, intend not to",
        "まったく～ない (mattaku~nai): not~at all",
        "も～ば～も (mo~ba~mo): …and…",
        "もかまわず (mo kamawazu): without worrying about",
        "ものだから (mono dakara): because, the reason is",
        "ものではない (mono dewa nai): shouldn't do something, it's impossible to do something",
        "ものがある (mono ga aru): [sentence-ending expression of strong judgement]",
        "ものか (mono ka): as if",
        "ものなら (mono nara): if one can do something",
        "ものの (mono no): but, although",
        "もっとも (motto mo): but then, although",
        "もう少しで (mou sukoshi de): almost, nearly",
        "むしろ (mushiro): rather, instead",
        "んだって (ndatte): I heard that",
        "中を (naka o): in, on",
        "なお (nao): furthermore, still, yet [used to add more information to the sentence]",
        "ないではいられない (nai dewa irarenai): can't help but feel, can't help but do",
        "ないことには～ない (nai koto niwa~nai): unless you do something",
        "なくはない (naku wa nai): it's not that…, can, may be",
        "なにも～ない (nani mo~nai): no need to",
        "ねばならない (neba naranai): have to, must",
        "にあたり (ni atari): at the time, on the occasion of",
        "に反して (ni han shite): against, contrary to",
        "にほかならない (ni hoka naranai): nothing but, none other than",
        "に限って (ni kagitte): only, particularly when",
        "に限らず (ni kagirazu): not just, not only… but also",
        "に限る (ni kagiru): nothing better than, there's nothing like",
        "にかかわる (ni kakawaru): to relate to, to have to do with",
        "にかかわらず (ni kakawarazu): regardless of",
        "に決まっている (ni kimatte iru): I'm sure that…",
        "に越したことはない (ni koshita koto wa nai): it's best that, there's nothing better than",
        "に応えて (ni kotaete): in response to",
        "に加えて (ni kuwaete): in addition to",
        "に基づいて (ni motozuite): based on",
        "にもかかわらず (nimo kakawarazu): despite, in spite of, although",
        "に向かって (ni mukatte): towards, to face, to head to",
        "に応じて (ni oujite): depending on, in accordance with",
        "に際して (ni sai shite): on the occasion of, at the time of",
        "に先立ち (ni sakidachi): before, prior to",
        "にしろ / にせよ (ni shiro/ni seyo): though, even if, whether… or",
        "にしろ～にしろ (ni shiro~ni shiro): whether… or",
        "に従って (ni shitagatte): as, therefore",
        "にしたら (ni shitara): from the point of view of",
        "にしても～にしても (ni shite mo~ni shite mo): regardless of whether",
        "に相違ない (ni soui nai): without a doubt, certain, sure",
        "に沿って (ni sotte): along with, in accordance with",
        "に過ぎない (ni suginai): no more than, just, merely",
        "にて (nite): in, at",
        "に伴って (ni tomonatte): as, due to",
        "につけ (ni tsuke): both… and…, every time something happens",
        "につき (ni tsuki): due to, because, per, each",
        "には (niwa): in order to, for",
        "にわたって (ni watatte): throughout, over (a period of time)",
        "のももっともだ (no mo mottomo da): no wonder, … is only natural",
        "のも当然だ (no mo touzen da): it's only natural that, no wonder",
        "のもとで (no moto de): under",
        "のみならず (nominarazu): not only, besides, as well",
        "抜きで/抜きにして (nuki de/nuki ni shite): leaving out, cutting out",
        "抜く (nuku): to do something to the end",
        "お～願う (o~negau): could you please",
        "を～として (o~to shite): as",
        "をこめて (o komete): filled with",
        "をきっかけに (o kikkake ni): with… as a start, as a result of",
        "を契機に (o keiki ni): as a good opportunity to, as a result of",
        "をめぐって (o megutte): concerning, in regard to",
        "をもとに (o moto ni): based on, from",
        "を除いて (o nozoite): except, with the exception of",
        "を問わず (o towazu): regardless of",
        "を通じて/ を通して (o tsuujite/o tooshite): via, through",
        "おまけに (omake ni): to make matters worse",
        "恐れがある (osore ga aru): there are fears that",
        "ろくに～ない (roku ni~nai): not doing something properly",
        "際に (sai ni): at the time, in case of",
        "幸い (saiwai): luckily, fortunately",
        "さらに (sara ni): furthermore, again, more and more",
        "せいぜい (seizei): at the most, at best",
        "せめて (semete): at least, at most",
        "次第 (shidai): as soon as",
        "次第だ/ 次第で (shidai da/shidai de): depending on, so",
        "しかも (shikamo): moreover, furthermore",
        "したがって (shitagatte): therefore, accordingly",
        "その上 (sono ue): besides, in addition, furthermore",
        "それなのに (sore na noni): and yet, despite this",
        "それなら (sore nara): then, if that's the case",
        "それにしても (sore ni shite mo): nevertheless, even so",
        "それとも (sore tomo): or, or else",
        "そういえば (sou ieba): come to think of it",
        "そうにない (sou ni nai): extremely unlikely to, showing no signs of",
        "そうすると (sou suru to): having done that",
        "少しも～ない (sukoshi mo~nai): not one bit, not even a little",
        "すなわち (sunawachi): in other words",
        "たあげく (ta ageku): to end up, finally",
        "直ちに (tadachi ni): at once, immediately",
        "たまえ (tamae): [order somebody to do something]",
        "た末 / の末 (ta sue/no sue): as a conclusion of",
        "たって (tatte): even if, even though, no matter how",
        "てばかりはいられない (te bakari wa irarenai): can't keep doing something",
        "てでも (te demo): even if one has to, by all means",
        "て以来 (te irai): since",
        "ていては (te ite wa): if one keeps doing something",
        "てからでないと (te kara denai to): unless, until",
        "てこそ (te koso): now that, since",
        "手前 (temae): before, in front of, from one's standpoint",
        "てならない (te naranai): very, extremely",
        "てしょうがない (te shou ga nai): very, extremely",
        "てたまらない (te tamaranai): very, extremely, can't help but do",
        "て当然だ (te touzen da): natural, as a matter of course",
        "ては (tewa): if, since, one after another",
        "てはいられない (tewa irarenai): can't afford to, unable to",
        "てはならない (tewa naranai): must not, cannot, should not",
        "と同時に (to douji ni): at the same time as",
        "というふうに (to iu fuu ni): in such a way that",
        "ということは (to iu koto wa): that is to say",
        "というものだ (to iu mono da): something like…, something called…",
        "というものでもない (to iu mono demo nai): there is no guarantee that…, not necessarily",
        "といった (to itta): such… as",
        "とか (toka): I heard that…",
        "と考えられる (to kangaerareru): one can think that…",
        "ところだった (tokoro datta): was just about to do something",
        "ところに/ところへ (tokoro ni/tokoro e): at the time",
        "ところを見ると (tokoro o miru to): judging from, seeing that",
        "とっくに (tokku ni): already, long ago",
        "とも (tomo): even if, no matter",
        "としても (to shite mo): assuming, even if",
        "としては (toshite wa): as for",
        "つもりで (tsumori de): with the intention of doing",
        "つつ (tsutsu): while, although",
        "つつある (tsutsu aru): to be doing",
        "上で (ue de): after",
        "上に (ue ni): as well, besides, in addition to",
        "上は (ue wa): now that, since",
        "は別として (wa betsu to shite): aside from",
        "はもとより (wa moto yori): also, let alone",
        "はともかく (wa tomokaku): whether or not",
        "わずかに (wazuka ni): slightly",
        "やがて (yagate): soon, before long, eventually",
        "やら～やら (yara~yara): such things as",
        "よりほかない (yori hoka nai): to have no choice but",
        "ようでは (you dewa): if",
        "ようがない/ようもない (you ga nai/you mo nai): there's no way to, it's impossible to",
        "要するに (you suru ni): the point is",
        "ざるを得ない (zaru o enai): can't help doing, have no choice but",
        "ずに済む (zu ni sumu): get by without doing something"
    ],
    "N1": [
        "あえて (aete): dare to",
        "あくまでも (akumade mo): to the end, to the utmost degree",
        "案の定 (an no jou): just as one thought",
        "あらかじめ (arakajime): beforehand, in advance",
        "あっての (atte no): to owe everything to",
        "場合によっては (baai ni yotte wa): depending on the situation",
        "ばこそ (ba koso): only because",
        "ばそれまでだ (ba sore made da): if… then it's over",
        "べからず (bekarazu): must not, should not",
        "べく (beku): in order to, should",
        "べくもない (beku mo nai): can't",
        "びる (biru): seeming to be",
        "ぶり (buri): style, manner",
        "ぶる (buru): behaving like",
        "だに (dani): even",
        "だの～だの (dano~dano): and, and so forth",
        "であれ～であれ (de are~de are): whether A or B",
        "であれ/であろうと (de are/de arou to): whoever/whatever/however",
        "でも何でもない (demo nan demo nai): not in the least",
        "でなくてなんだろう (denakute nan darou): must be, is definitely",
        "ではあるまいか (dewa aru mai ka): I wonder if it's not",
        "ではあるまいし (dewa aru mai shi): it's not like, it isn't as if",
        "ではすまない (dewa sumanai): it doesn't end with just",
        "どうにも～ない (dou nimo~nai): not … by any means",
        "がてら (gatera): on the same occasion",
        "が早いか (ga hayai ka): as soon as",
        "が最後 (ga saigo): once something occurs, something else happens",
        "ごとき/ごとく (gotoki/gotoku): like, as if",
        "ぐるみ (gurumi): together with",
        "羽目になる (hame ni naru): to end up with (something unpleasant)",
        "ひとつ (hitotsu): to give something a try",
        "ほどのことはない (hodo no koto wa nai): not worth, no need to",
        "ほかに～ない (hoka ni~nai): no other",
        "ほうがましだ (hou ga mashi da): I would rather",
        "いかなる (ikanaru): any kind of",
        "いかんでは/いかんによっては (ikan dewa/ikan ni yotte wa): depending on",
        "いかんによらず (ikan ni yorazu): regardless of",
        "いかに (ikani): how",
        "いかにも (ikanimo): indeed, really",
        "いまだに (ima da ni): still, even now",
        "いずれにせよ (izure nise yo): at any rate, in any case",
        "じみた (jimita): to look like",
        "限りだ (kagiri da): I feel so",
        "かいもなく (kai mo naku): even though",
        "か否か (ka ina ka): whether or not",
        "可能性がある (kanousei ga aru): there's a possibility",
        "からある (kara aru): as much as, as many as",
        "かれ～かれ (kare~kare): or",
        "かたがた (katagata): while, for the purpose of",
        "かたわら (katawara): while, at the same time",
        "かつて (katsute): once, before",
        "嫌いがある (kirai ga aru): to have a tendency to",
        "きっての (kitte no): the most … of all",
        "きりがない (kiri ga nai): there's no end to",
        "極まる/極まりない (kiwamaru/kiwamarinai): extremely",
        "極めて (kiwamete): extremely, exceedingly",
        "ことだし (koto dashi): because, since",
        "ことごとく (koto gotoku): altogether, entirely",
        "ことなしに (koto nashi ni): without doing something",
        "ことのないよう (koto no nai you): so as not to",
        "こととて (kototote): because, since",
        "くらいなら (kurai nara): rather than",
        "くらいのものだ (kurai no mono da): only",
        "までだ (made da): only",
        "までもない (made mo nai): it's not necessary to",
        "まじき (majiki): should not, must not",
        "ままに (mama ni): to do as",
        "まみれ (mamire): to be covered in",
        "まるっきり (marukkiri): totally, completely",
        "めく (meku): to show signs of",
        "もはや (mohaya): already, no longer",
        "も顧みず/を顧みず (mo kaerimizu/o kaerimizu): regardless of, despite",
        "もしないで (mo shinaide): without even doing",
        "もので (mono de): because, for that reason",
        "ものを (mono o): I wish, if only",
        "ものと思われる (mono to omowareru): to think, to suppose",
        "ものとして (mono toshite): to assume, to suppose",
        "もさることながら (mo saru koto nagara): not only… but also",
        "もしくは (moshikuwa): or, otherwise",
        "ながらに/ながらの (nagara ni/nagara no): while, during",
        "ないではおかない/ずにはおかない (nai dewa okanai/zu niwa okanai): will definitely, cannot not",
        "ないではすまない/ずにはすまない (nai dewa sumanai/zu niwa sumanai): must",
        "ないまでも (nai made mo): even if something isn't done",
        "ないものか (nai mono ka): can't we…?, can't I…?",
        "ないものでもない (nai mono demo nai): (something) is not entirely impossible",
        "ないとも限らない (nai tomo kagiranai): might",
        "なくして (nakushite): without",
        "何しろ (nani shiro): in any case, as you know",
        "なしに (nashi ni): without",
        "ならでは (nara dewa): uniquely applying to",
        "ならいざしらず (nara iza shirazu): I don't know about A, but B",
        "なり (nari): as soon as",
        "なり～なり (nari~nari): or",
        "なりに/なりの (nari ni/nari no): in one's own way or style",
        "なりとも (naritomo): even a little, at least",
        "に値する (ni atai suru): to be worth, to deserve",
        "にあたらない (ni ataranai): it's not worth, there's no need to",
        "にあって (ni atte): at, during, in the condition of",
        "にひきかえ (ni hikikae): in contrast to",
        "に至るまで (ni itaru made): until, as far as",
        "に至っては (ni itatte wa): as for, when it comes to",
        "に言わせれば (ni iwasereba): if you ask, if one may say",
        "にかかっている (ni kakatte iru): to depend on",
        "にかたくない (ni katakunai): it's not hard to",
        "にまつわる (ni matsuwaru): to be related to",
        "にもほどがある (nimo hodo ga aru): to have a limit, to go too far",
        "にもまして (ni momashite): more than, above",
        "に則って (ni nottotte): in accordance with",
        "に先駆けて (ni saki gakete): to be the first",
        "にしたって (ni shitatte): even, even if",
        "にして (ni shite): only, in (time span)",
        "に即して (ni sokushite): in keeping with",
        "にたえる/にたえない (ni taeru/ni taenai): can/can't do something",
        "に足る/に足りる (ni taru/ni tariru): to be enough, to be worthy of",
        "に足りない (ni tarinai): to be not worth",
        "に照らして (ni terashite): in comparison with, according to",
        "にとどまらず (ni todomarazu): not limited to",
        "には及ばない (niwa oyobanai): there's no need to",
        "によらず (ni yorazu): regardless of",
        "んばかりに (n bakari ni): as if, as though",
        "んがため (n ga tame): in order to",
        "の至り (no itari): utmost",
        "の極み (no kiwami): utmost",
        "のみか (nomika): not only… but also",
        "のなんのって (no nan no tte): extremely",
        "を踏まえて (o fumaete): based on",
        "を経て (o hete): through, after, via",
        "をいいことに (o ii koto ni): to take advantage of",
        "を限りに (o kagiri ni): starting from",
        "を兼ねて (o kanete): also for the purpose of",
        "を皮切りに (o kawakiri ni): starting with",
        "を機に (o ki ni): as an opportunity to",
        "を禁じえない (o kinjienai): can't help but",
        "をものともせず (o monotomo sezu): in defiance of",
        "をもって (o motte) – 1: by means of",
        "をもって (o motte) – 2: at the time",
        "をおいて (o oite): other than, without",
        "を余儀なくされる (o yogi naku sareru): to be forced to do something",
        "をよそに (o yoso ni): despite",
        "思いをする (omoi o suru): to feel",
        "折に (ori ni): when, on the occasion",
        "およそ (oyoso): totally, (not) at all",
        "さもないと (samonaito): otherwise, else, if not so",
        "さぞ (sazo): I'm sure, I'm certain",
        "始末だ (shimatsu da): end up, in the end",
        "そばから (soba kara): as soon as",
        "さも (samo): truly, really",
        "それなりに (sore nari ni): as it is, in its own way",
        "そうにもない (sou nimo nai): impossible, unlikely",
        "ただ～のみだ (tada~nomi da): can do nothing but",
        "た拍子に (ta hyoushi ni): the instant",
        "ためしがない (tameshi ga nai): (something) is never the case",
        "たりとも (taritomo): (not) even, (not) any",
        "た瞬間に (ta shunkan ni): the moment",
        "てっきり (tekkiri): surely, certainly",
        "たところで (ta tokoro de): even if one does something",
        "てからというもの (te kara to iu mono): after, since",
        "てかなわない (te kanawanai): can't stand, unable to",
        "てまで (te made): even",
        "てみせる (te miseru): I'll definitely",
        "てもどうにもならない (temo dou nimo naranai): it's no use",
        "ても始まらない (temo hajimaranai): it's no use",
        "ても差し支えない (temo sashitsukaenai): can, it's okay if",
        "てしかるべきだ (te shikaru beki da): should",
        "ってば (tteba): I said, I told you to",
        "てやまない (te yamanai): always, never stop",
        "と相まって (to aimatte): together with",
        "とあれば (to areba): if, if it's the case that",
        "とあって (to atte): because of",
        "とばかりに (to bakari ni): as if, as though",
        "といえども (to ie domo): even, even if",
        "といい～といい (to ii~to ii): and, or",
        "といったらない (to ittara nai): very, extremely",
        "という (to iu): all, every",
        "というか (to iu ka): or, or more precisely",
        "というか～というか (to iu ka~to iu ka): (I'm not sure if it's) A or B",
        "というところだ/といったところだ (to iu tokoro da/to itta tokoro da): approximately, about",
        "というもの (to iu mono): during a period of time",
        "というわけだ (to iu wake da): this means",
        "というわけではない (to iu wake dewa nai): it's not that, it doesn't mean that",
        "といわず (to iwazu): not just, both",
        "ときたら (tokitara): when it comes to, concerning",
        "ときている (to kite iru): because",
        "ところがある (tokoro ga aru): there is",
        "ところから (tokoro kara): from the fact that",
        "とみられる (to mirareru): to be regarded as, to be expected to",
        "とみるや (to miru ya): at the sight of, upon seeing",
        "ともなく (tomonaku): to do something without thinking about it",
        "ともなると/ともなれば (tomo naru to/tomo nareba): when, once (something happens)",
        "ともすれば (tomo sureba): apt to, prone to",
        "と思いきや (to omoikiya): I thought",
        "とりわけ (toriwake): especially",
        "とされる (to sareru): is considered",
        "とっさに (tossa ni): at once, right away",
        "としたって/としたところで (to shitatte/to shita tokoro de): even if",
        "として～ない (toshite~nai): not even one",
        "とて (tote): even if, even though",
        "とても～ない (totemo~nai): cannot possibly",
        "とは (towa): [indicates word or phrase being defined]",
        "とはいえ (towaie): nonetheless, although",
        "とはいうものの (towa iu mono no): having said that, be that as it may",
        "つ～つ (tsu~tsu): [indicates two contrasting actions]",
        "はおろか (wa oroka): let alone, not to mention",
        "はさておき (wa sateoki): setting aside",
        "や否や (ya ina ya): the moment that, as soon as",
        "やしない (yashinai): not (emphatic negative)",
        "(よ)うが/(よ)うと (you ga/you to): no matter how/what",
        "(よ)うが～まいが/(よ)うと～まいと (you ga~mai ga/you to~mai to): whether or not",
        "(よ)うか～まいか (you ka~mai ka): whether or not",
        "(よ)うものなら (you mono nara): if one chooses to",
        "(よ)うにも～ない (you nimo~nai): even if one tries to do something, it can't be done",
        "ようによっては (you ni yotte wa): depending on",
        "ゆえに (yue ni): therefore, consequently",
        "ざる (zaru): not, -un",
        "ずじまい (zu jimai): never",
        "ずくめ (zukume): entirely, completely",
        "ずとも (zu tomo): even without doing"
    ]

};

//
// Sub-Components for the different modes
//

// Vocabulary Mode: Render vocabulary level selector and topic selection.
function JapaneseVocabularyMenu({
    selectedVocabularyLevels,
    setSelectedVocabularyLevels,
    selectedTopics,
    setSelectedTopics,
    customTopicEnabled,
    setCustomTopicEnabled,
    customTopic,
    setCustomTopic,
    openDropdown,
    setOpenDropdown,
}) {
    return (
        <>
            <CollapsibleSection
                label="Select Vocabulary Level"
                isOpen={openDropdown === 'Japanese_SelectVocabularyLevel'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Japanese_SelectVocabularyLevel' ? null : 'Japanese_SelectVocabularyLevel')
                }
            >
                <div className="vocab-level-checkbox-group">
                    {["N5", "N4", "N3", "N2", "N1"].map((level) => (
                        <label key={level} className="vocab-level-checkbox-label option-label">
                            <input
                                type="checkbox"
                                name="vocabularyLevel"
                                value={level}
                                checked={selectedVocabularyLevels.includes(level)}
                                onChange={(e) => {
                                    let newSelected = [...selectedVocabularyLevels];
                                    if (e.target.checked) {
                                        newSelected.push(level);
                                    } else {
                                        newSelected = newSelected.filter((v) => v !== level);
                                    }
                                    setSelectedVocabularyLevels(newSelected);
                                }}
                            />
                            {level}
                        </label>
                    ))}
                </div>
            </CollapsibleSection>
            <CollapsibleSection
                label="Select Topics"
                isOpen={openDropdown === 'Japanese_SelectTopics'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Japanese_SelectTopics' ? null : 'Japanese_SelectTopics')
                }
            >
                <div style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden', paddingRight: '10px' }}>
                    {topicsList.map((topic, index) => (
                        <div key={index}>
                            <label className="home-menu-label option-label">
                                <input
                                    type="checkbox"
                                    checked={selectedTopics.includes(topic)}
                                    onChange={() => {
                                        if (selectedTopics.includes(topic)) {
                                            setSelectedTopics(selectedTopics.filter((t) => t !== topic));
                                        } else {
                                            setSelectedTopics([...selectedTopics, topic]);
                                        }
                                    }}
                                />
                                {topic}
                            </label>
                        </div>
                    ))}
                </div>
                <div className="custom-topic-container" style={{ marginTop: '10px' }}>
                    <label className="home-menu-label option-label">
                        <input
                            type="checkbox"
                            checked={customTopicEnabled}
                            onChange={(e) => {
                                setCustomTopicEnabled(e.target.checked);
                                if (!e.target.checked) {
                                    setCustomTopic("");
                                }
                            }}
                        />
                        Custom
                    </label>
                    {customTopicEnabled && (
                        <div style={{ marginTop: '5px' }}>
                            <input
                                type="text"
                                value={customTopic}
                                onChange={(e) => setCustomTopic(e.target.value)}
                                placeholder="Enter your custom topic"
                                style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', color: '#333' }}
                            />
                            <div style={{ fontSize: '0.8em', fontStyle: 'italic', marginTop: '3px', color: '#333' }}>
                                Or select from the topics above.
                            </div>
                        </div>
                    )}
                </div>
            </CollapsibleSection>

        </>
    );
}

// Grammar Mode: Render vocabulary level selector and grammar items per level.
function JapaneseGrammarMenu({
    selectedVocabularyLevels,
    setSelectedVocabularyLevels,
    selectedGrammarItems,
    setSelectedGrammarItems,
    selectedTopics,
    setSelectedTopics,
    customTopicEnabled,
    setCustomTopicEnabled,
    customTopic,
    setCustomTopic,
    openDropdown,
    setOpenDropdown,
}) {
    return (
        <>
            <CollapsibleSection
                label="Select Grammar Level"
                isOpen={openDropdown === 'Japanese_SelectGrammarLevel'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Japanese_SelectGrammarLevel' ? null : 'Japanese_SelectGrammarLevel')
                }
            >
                <div className="vocab-level-checkbox-group">
                    {["N5", "N4", "N3", "N2", "N1"].map((level) => (
                        <label key={level} className="vocab-level-checkbox-label option-label">
                            <input
                                type="checkbox"
                                name="vocabularyLevel"
                                value={level}
                                checked={selectedVocabularyLevels.includes(level)}
                                onChange={(e) => {
                                    let newSelected = [...selectedVocabularyLevels];
                                    if (e.target.checked) {
                                        newSelected.push(level);
                                    } else {
                                        newSelected = newSelected.filter((v) => v !== level);
                                        setSelectedGrammarItems((prev) => {
                                            const updated = { ...prev };
                                            delete updated[level];
                                            return updated;
                                        });
                                    }
                                    setSelectedVocabularyLevels(newSelected);
                                }}
                            />
                            {level}
                        </label>
                    ))}
                </div>
            </CollapsibleSection>

            {/* Grammar Item Selection (Moved Up) */}
            {selectedVocabularyLevels.map((level) => (
                (japaneseGrammarItems[level]?.length > 0) && (
                    <CollapsibleSection
                        key={level}
                        label={`${level} Grammar`}
                        isOpen={openDropdown === `Japanese_Grammar_${level}`}
                        onToggle={() =>
                            setOpenDropdown(openDropdown === `Japanese_Grammar_${level}` ? null : `Japanese_Grammar_${level}`)
                        }
                    >
                        <div style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden', paddingRight: '10px' }}>
                            {(japaneseGrammarItems[level] || []).map((item, idx) => {
                                const isChecked = (selectedGrammarItems[level] || []).includes(item);
                                return (
                                    <div key={idx}>
                                        <label className="home-menu-label option-label">
                                            <input
                                                type="checkbox"
                                                checked={isChecked}
                                                onChange={() => {
                                                    const current = selectedGrammarItems[level] || [];
                                                    let newSelection;
                                                    if (isChecked) {
                                                        newSelection = current.filter((i) => i !== item);
                                                    } else {
                                                        newSelection = [...current, item];
                                                    }
                                                    setSelectedGrammarItems((prev) => ({
                                                        ...prev,
                                                        [level]: newSelection,
                                                    }));
                                                }}
                                            />
                                            {item}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </CollapsibleSection>
                )
            ))}

            {/* Topic Selection (Now Last) */}
            <CollapsibleSection
                label="Select Topics"
                isOpen={openDropdown === 'Japanese_SelectTopics'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Japanese_SelectTopics' ? null : 'Japanese_SelectTopics')
                }
            >
                <div style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden', paddingRight: '10px' }}>
                    {topicsList.map((topic, index) => (
                        <div key={index}>
                            <label className="home-menu-label option-label">
                                <input
                                    type="checkbox"
                                    checked={selectedTopics.includes(topic)}
                                    onChange={() => {
                                        if (selectedTopics.includes(topic)) {
                                            setSelectedTopics(selectedTopics.filter((t) => t !== topic));
                                        } else {
                                            setSelectedTopics([...selectedTopics, topic]);
                                        }
                                    }}
                                />
                                {topic}
                            </label>
                        </div>
                    ))}
                </div>
                <div className="custom-topic-container" style={{ marginTop: '10px' }}>
                    <label className="home-menu-label option-label">
                        <input
                            type="checkbox"
                            checked={customTopicEnabled}
                            onChange={(e) => {
                                setCustomTopicEnabled(e.target.checked);
                                if (!e.target.checked) {
                                    setCustomTopic("");
                                }
                            }}
                        />
                        Custom
                    </label>
                    {customTopicEnabled && (
                        <div style={{ marginTop: '5px' }}>
                            <input
                                type="text"
                                value={customTopic}
                                onChange={(e) => setCustomTopic(e.target.value)}
                                placeholder="Enter your custom topic"
                                style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', color: '#333' }}
                            />
                            <div style={{ fontSize: '0.8em', fontStyle: 'italic', marginTop: '3px', color: '#333' }}>
                                Or select from the topics above.
                            </div>
                        </div>
                    )}
                </div>
            </CollapsibleSection>
        </>
    );
}

// Main JapaneseMenu component always renders the Learning Mode section at the top.
const JapaneseMenu = (props) => {
    const { learningMode, openDropdown, setOpenDropdown } = props;
    return (
        <div>
            <CollapsibleSection
                label="Learning Mode"
                isOpen={openDropdown === 'Japanese_LearningMode'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Japanese_LearningMode' ? null : 'Japanese_LearningMode')
                }
            >
                <div>
                    <label className="home-menu-label option-label">
                        <input
                            type="radio"
                            name="learningMode"
                            value="Vocabulary"
                            checked={learningMode === "Vocabulary"}
                            onChange={(e) => props.setLearningMode(e.target.value)}
                        />
                        Vocabulary
                    </label>
                </div>
                <div>
                    <label className="home-menu-label option-label">
                        <input
                            type="radio"
                            name="learningMode"
                            value="Grammar"
                            checked={learningMode === "Grammar"}
                            onChange={(e) => props.setLearningMode(e.target.value)}
                        />
                        Grammar
                    </label>
                </div>
            </CollapsibleSection>
            {learningMode === "Grammar" ? (
                <JapaneseGrammarMenu {...props} />
            ) : (
                <JapaneseVocabularyMenu {...props} />
            )}
        </div>
    );
};

export default JapaneseMenu;
